import React from 'react';
import CardItem from "../CardItem";
import card_nft from "../../assets/images/card_nft.png";

const CardsBlock = () => {
    const cards = [
        {
            img: card_nft,
            cashPerDay: 100,
            cashAccured: 100
        },
        {
            img: card_nft,
            cashPerDay: 1000,
            cashAccured: 1000
        },
        {
            img: card_nft,
            cashPerDay: 10000,
            cashAccured: 10000
        },
        {
            img: card_nft,
            cashPerDay: 100000,
            cashAccured: 100000
        },
        {
            img: card_nft,
            cashPerDay: 10000000,
            cashAccured: 10000000
        },
        {
            img: card_nft,
            cashPerDay: 100000000,
            cashAccured: 100000000
        },
        {
            img: card_nft,
            cashPerDay: 1000000000,
            cashAccured: 1000000000
        },
    ]

    return (
        <div className="mt-28 mx-5 lg:mx-20">
            <div className="flex flex-col lg:flex-row justify-between">
                <h1 className="text-[40px]">Your Rolling Bones NFT</h1>
                <div className="flex flex-col lg:flex-row gap-4 lg:gap-10 place-self-start lg:place-self-end">
                    <h1 className="text-[28px] font-gilroy font-semibold">Quantity NFT: 100</h1>
                    <div
                        className="bg-[#5599FF] cursor-pointer w-[160px] h-[45px] flex rounded-[10px] place-items-center font-semibold justify-center">
                        <p className="font-gilroy">Stake all</p>
                    </div>
                    <div
                        className="bg-[#F155FF] cursor-pointer w-[160px] h-[45px] flex rounded-[10px] place-items-center font-semibold justify-center">
                        <p className="font-gilroy">Unstake all</p>
                    </div>
                </div>
            </div>
            <div
                className="grid gap-y-8 grid-cols-[repeat(auto-fit,_minmax(300px,_1fr))] bg-black bg-opacity-60 h-[550px] py-5 px-5 rounded-[30px] mt-5 overflow-y-scroll">
                {
                    cards.map(card => {
                        return <CardItem cardImg={card.img} cashPerDay={card.cashPerDay} cashAccured={card.cashAccured}/>
                    })
                }
            </div>
        </div>
    );
};

export default CardsBlock;